import { postOneTimeCodeCreate } from '@/api/postOneTimeCodeCreate';

// window.openがsafariで効かないので、location.hrefを用いて遷移
export const goMainOneTimeAuth = async ({
  redirectPath = '/',
  token,
}: {
  redirectPath?: string;
  token?: string;
}) => {
  if (!process.env.NEXT_PUBLIC_SERVICE_ID) return;
  const { result } = await postOneTimeCodeCreate({
    oemServiceId: process.env.NEXT_PUBLIC_SERVICE_ID,
    token: token,
  });
  const url = `${process.env.NEXT_PUBLIC_MAIN_URL}/one-time-auth?code=${result.authCode}&redirect_path=${redirectPath}`;
  location.href = url;
};

/**
 * @deprecated これらの関数は @monorepo/common から直接インポートしてください
 * 例: import { locationHref, scrollIntoTheView, pickErrorMessages } from '@monorepo/common'
 */
export { locationHref, pickErrorMessages, scrollIntoTheView } from '@monorepo/common';
